import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Custom tailwind-merge configuration to handle our custom utilities
// We need to tell tailwind-merge that our typography utilities (text-body2, text-micro, etc.)
// should NOT conflict with text color utilities (text-success-foreground, etc.)
const customTwMerge = extendTailwindMerge({
  override: {
    classGroups: {
      // Override the default 'text-color' group to exclude our typography utilities
      // This allows text-body2 and text-success-foreground to coexist
      'font-size': [
        // Add our custom typography utilities to font-size group
        'text-story',
        'text-h1',
        'text-h2',
        'text-h3',
        'text-h4',
        'text-body1',
        'text-body2',
        'text-label1',
        'text-label2',
        'text-body-mono1',
        'text-body-mono2',
        'text-body-paragraph1',
        'text-body-paragraph2',
        'text-micro',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

/**
 * Text alignment options
 */
export type Alignment = 'left' | 'center' | 'right';

/**
 * Get flex alignment CSS class
 */
export function getFlexAlignmentClass(align?: Alignment): string | null {
  if (align === 'center') return 'justify-center';
  if (align === 'right') return 'justify-end';
  return null;
}
